import { MultiSelect } from 'Shared/forms/Inputs';
import { useStore, cloneSw, StoreProvider } from 'Shared/StoreProvider';
import { useSite } from 'Shared/SiteProvider';
import { VenueSettingsFactory } from 'Shared/VenueSettingsFactory';
import { createMemo } from 'solid-js';


export function ClassesUi()
{
	const sw = useStore();
	const parentSw = { ...cloneSw(sw), location: (sw.location ?? []).slice(0, -3) };

	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key).siteTheme();

	const options = createMemo(() => {
		const ret: Record<string, string> = {};
		for (const key of siteTheme.classes) ret[key] = key;
		return ret;
	});

	return (
		<StoreProvider {...parentSw}>
			<MultiSelect field='classes' options={options()} />
		</StoreProvider>
	);
}
